export default (() => {
    const productButtons = Array.from(document.querySelectorAll('.js-product-button'));

    productButtons.forEach((button) => {
        button.addEventListener('click', () => {
            window.dataLayer.push({
                event: 'productClick',
                product: button.dataset.product
            });
        });
    });
})();
